<template>
	<div style="text-align: left; padding: 1px; width: 100%; height: 915px; overflow-y: auto;"> <!-- 新增浮云容器 -->
		<el-table :data="tableData" border style="width: 100%">
			<el-table-column prop="name" label="前置机名称">
				<template slot-scope="scope">
					{{ scope.row.hostName }}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="申请时间">
			</el-table-column>
			<el-table-column prop="cpuInfo" label="电脑内核">
			</el-table-column>
			<el-table-column prop="diskInfo" label="硬盘容量">
			</el-table-column>
			<el-table-column prop="macAddresses" label="mac">
			</el-table-column>
			<el-table-column prop="publicIp" label="注册IP">
			</el-table-column>

			<el-table-column prop="tunnelsId" label="隧道ID">
			</el-table-column>

			<el-table-column prop="remark" label="备注">
			</el-table-column>

			<el-table-column prop="status" label="使用状态">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.isClose === '0'" type="info">已通过</el-tag>
					<el-tag v-else-if="scope.row.isClose === '1'" type="success">已拒绝</el-tag>
					<el-tag v-else type="danger">待处理</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="handleClick(scope.row, '1')" type="primary" size="small" v-if="scope.row.isClose === null">通过</el-button>
				</template></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { sysRegisterList, sysRegisterUpdate } from '@/public/api.js'

// 引入路由实例
export default {
	name: 'register',
	components: {

	},
	data() {
		return {
			formData: [], // 改为数组类型，确保Vue能正确追踪变化
			tableData: []
		}
	},
	mounted() {
		if( JSON.parse(localStorage.getItem('updateUserName')).value !== 'root' ){
			// 清除登录状态
			localStorage.removeItem('showHome');
			localStorage.removeItem('transferDepartmentListData');
			localStorage.removeItem('updateLhTunnels');
			localStorage.removeItem('updateToken');
			localStorage.removeItem('updateTokenPass');
			localStorage.removeItem('updateTunnelDeptId');
			localStorage.removeItem('updateTunnelItemId');
			localStorage.removeItem('updateTunnelNumber');
			localStorage.removeItem('projecTenusData');
			this.$router.push('/login');
		}
		
		this.getList();
		setInterval(() => {
			this.getList();
		}, 10000);
	},
	methods: {
		getList() {
			let that = this;
			sysRegisterList({  }).then(res => {
				that.tableData = res.data.data;
			})
		},
		// 处理注册信息更新
		handleClick(item, status) {
			let that = this;
			item.isClose = '0';
			item.delFlag = '0';
			// 提交数据到后端
			sysRegisterUpdate(item).then(res => {
				if (res.data.code !== 200) {
					that.$message.error(res.data.message);
				} else {
					that.$message.success('修改成功');
					that.getList();
				}
			})
		},
		getMinutesDifference(timeString) {
			const targetTime = new Date(timeString);

			if (isNaN(targetTime.getTime())) {
				throw new Error("无效的时间字符串");
			}

			const now = new Date();
			const diffMs = targetTime - now;
			const diffMinutes = Math.round(diffMs / (1000 * 60));

			return diffMinutes;
		}
	}
}
</script>
<style scoped>
.box-card {
	margin-bottom: 10px;
}

.header {
	padding: 10px;
	background-color: #f5f5f5;
	border-bottom: 1px solid #e5e5e5;
	margin-bottom: 5px;
}

.text.item {
	background-color: #f9f9f9;
	/* 设置浅灰色背景 */
	padding: 15px;
	border-radius: 4px;

	/* 设置禁用输入框的背景颜色为白色 */
	.el-input.is-disabled .el-input__inner {
		background-color: #ffffff !important;
	}
}
</style>